// https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories

const userKeys = {
  all: ['user'] as const,
  user: (userId: number) => [...userKeys.all, userId] as const,
};

export default userKeys;
